"use client";

import { Star } from "lucide-react";
export default function ClientVoices() {
  const reviews = [{
    name: "Sarah M.",
    date: "MAR 12, 2025",
    rating: 5,
    quote: "Coach Kira's programs are transformative. The attention to form and personalized nutrition advice helped me hit my PRs in just three months.",
    role: "Strength Athlete"
  }, {
    name: "James P.",
    date: "FEB 28, 2025",
    rating: 5,
    quote: "I never thought I could enjoy working out. Kira makes every session challenging but incredibly rewarding. Best investment in my health.",
    role: "Corporate Professional"
  }, {
    name: "Elena V.",
    date: "FEB 14, 2025",
    rating: 5,
    quote: "The virtual coaching sessions are seamless. Kira’s expertise in functional movement has completely eliminated my chronic back pain.",
    role: "Remote Worker"
  }, {
    name: "Marcus L.",
    date: "JAN 30, 2025",
    rating: 5,
    quote: "Precision, motivation, and results. Kira doesn't just give you a plan; she teaches you how to master your own body.",
    role: "Fitness Enthusiast"
  }, {
    name: "Priya K.",
    date: "JAN 18, 2025",
    rating: 4,
    quote: "The progress tracking is so detailed. I love seeing the data behind my improvements every single week.",
    role: "Client"
  }, {
    name: "Daniel O.",
    date: "JAN 05, 2025",
    rating: 5,
    quote: "Kira is the real deal. She treats every client like an athlete, regardless of their starting point. Highly recommended.",
    role: "Long-term Client"
  }];
  return <section data-section-id="1528" id="client-voices" className="relative overflow-hidden bg-background text-foreground py-24 md:py-32 border-y border-border">
      {}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none opacity-[0.05]" style={{
      backgroundImage: "radial-gradient(circle, hsl(var(--foreground)) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} />

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-8">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-16 md:mb-20">
          <div className="lg:col-span-7">
            
            <h2 className="font-default font-bold uppercase text-foreground leading-[0.92] tracking-[-0.02em] text-[clamp(2.5rem,5.5vw,5rem)]">
              RESULTS{" "}
              <span className="inline-block bg-accent text-accent-foreground border border-foreground px-3 md:px-5 py-0 md:py-1">
                DRIVEN
              </span>{" "}
              BY DATA
            </h2>
            <p className="mt-8 font-default text-foreground/80 text-lg md:text-xl max-w-xl leading-relaxed">
              Real stories from our community —{" "}
              <span className="font-bold text-primary">4.9 </span> average rating across 500+ transformations.
            </p>
          </div>

          <div className="lg:col-span-5 flex lg:justify-end lg:items-start">
            {}
            <div className="relative inline-block">
              
              
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((review, i) => <article key={i} data-index={i} className="bg-card border border-border p-6 md:p-7 shadow-md">
              {}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({
              length: 5
            }).map((_, s) => <Star key={s} className="size-5" strokeWidth={2} stroke="hsl(var(--foreground))" fill={s < review.rating ? "hsl(var(--primary))" : "transparent"} />)}
              </div>

              {}
              <h3 className="font-default font-bold uppercase text-foreground text-xl md:text-2xl leading-none tracking-[-0.02em]">
                {review.name}
              </h3>

              {}
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mt-2 mb-5">
                {review.date}
              </p>

              {}
              <p className="font-default text-foreground/90 text-[1.0625rem] leading-relaxed">
                &ldquo;{review.quote}&rdquo;
              </p>

              {}
              <div className="mt-6 pt-5 border-t border-border flex items-center justify-between">
                <p className="font-default text-sm text-muted-foreground">
                  {review.role}
                </p>
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center justify-center size-7 border border-foreground font-default font-bold text-foreground text-sm" aria-hidden="true">
                    K
                  </span>
                  <span className="font-mono text-[0.7rem] uppercase tracking-[0.2em] text-foreground">
                    COACH KIRA
                  </span>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}